module.exports = __webpack_public_path__ + "img/20210319.cd6be912.png";